
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/password",
      function () {
        return require("private-next-pages/password.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/password"])
      });
    }
  